export const useOpdekdeurHingeHeight = () => {
  const getHingeHeight = (
    doorHeight: number,
    hingeAmount: number,
    hingeIndex: number,
  ): number => {
    switch (hingeIndex) {
      case 0:
        if (doorHeight <= 2064) return 240;
        return 340;
      case 1:
        if (hingeAmount === 2) {
          if (doorHeight <= 2064) return 1740;
          else if (doorHeight > 2064 && doorHeight <= 2115) return 1840;
        } else if (hingeAmount === 3) {
          if (doorHeight <= 2064) return 440;
          else if (doorHeight > 2064 && doorHeight <= 2505) return 540;
          return 740;
        }
        return 0;
      case 2:
        if (doorHeight <= 2064) return 1740;
        else if (doorHeight > 2064 && doorHeight <= 2269) return 1840;
        else if (doorHeight > 2269 && doorHeight <= 2421) return 2040;
        else if (doorHeight > 2421 && doorHeight <= 2505) return 2221;
        else if (doorHeight > 2505 && doorHeight <= 2520) return 2236;
        else if (doorHeight > 2520 && doorHeight <= 2535) return 2251;
        else if (doorHeight > 2535 && doorHeight <= 2550) return 2266;
        else if (doorHeight > 2550 && doorHeight <= 2565) return 2281;
        else if (doorHeight > 2565 && doorHeight <= 2580) return 2296;
        return 2311;
      default:
        return 0;
    }
  };

  return { getHingeHeight };
};
